import { Info } from "lucide-react"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

export default function NotSharableState() {
  return (
    <div className="flex-1 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <Alert>
          <Info className="h-4 w-4" />
          <AlertTitle>Not Shareable</AlertTitle>
          <AlertDescription>
            This preview is not currently set to be shareable. Please contact the owner to enable sharing for this
            preview.
          </AlertDescription>
        </Alert>
      </div>
    </div>
  )
}

